import React from "react";
import UserDetailContainer from "../containers/UserDetail";

const UserDetail = () => {
  return <UserDetailContainer />;
};

export default UserDetail;
